import { enableProdMode, provideZoneChangeDetection } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";

import { AppModule } from "./app/app.module";
import { environment } from "./environments/environment";
import { AppConfig } from "./app/shared/config";
import { CommonUtils } from "./app/features/fnol/shared/utils/common-utils";

if (environment.production) {
  enableProdMode();
}
let url = AppConfig.getConfigUrl();
console.log('Config URL.', url);
// 1. Get the query string (e.g., "?id=123&user=jsmith")
const queryString = window.location.search;

// 2. Parse the parameters
const urlParams = new URLSearchParams(queryString);

// 3. Retrieve specific values
const country = urlParams.get('country')?.toLowerCase()==="singapore"?"sg":"jp"; // "123"
const policyId = urlParams.get('policyId');
if(country === "sg" && policyId) {
  CommonUtils.isDmpCDPSingnpassFlow = true;
  CommonUtils.isRouteAllowed = true;
}


fetch(url)
  .then(async (res) => {
    let configJson = await res.json();
    configJson.oktaConfig = configJson.oktaCountriesConfig[country];
    configJson.oktaConfig.redirectUri =
      window.location.origin + configJson.oktaCountriesConfig[country].redirectUri;
    configJson.oktaConfig.postLogoutRedirectUri =
      window.location.origin + configJson.oktaCountriesConfig[country].postLogoutRedirectUri;

    AppConfig.setEnvConfig(configJson);

    platformBrowserDynamic([
      { provide: AppConfig, useValue: AppConfig.oktaConfig },
    ])
      .bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], })
      .catch((err) => console.error(err));
  })
  .catch((err) => {
    console.log("error reading config file: ", err);
  });
